import React, {useState} from 'react';
import axios from 'axios';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import Loading from "@/components/Loading";

export default function Qrcode() {

    //API client/qr/{qrcode}

    const navigate = useNavigate();

    const params = useParams();
    const location = useLocation();

    const [loading, setLoading] = useState(true);

    React.useEffect(() => {
        console.log("navigate is loaded, we're ready to redirect");
        console.log(params);

        console.log(`checking code ${params.qrcode}`);

        // Track page view
        var _paq = window._paq = window._paq || [];
        _paq.push(['setCustomUrl', location.pathname]);
        _paq.push(['setDocumentTitle', 'QR Code ' + params.qrcode]);
        _paq.push(['trackPageView']);

        const fetchData = async () => {
            try {
                const response = await axios.get(process.env.CLIENT_API_URL + `/client/qr/${params.qrcode}`);
                setLoading(false);

                const destinationUrl = response.data.destination;
                if (destinationUrl) {
                    try {
                        const parsedUrl = new URL(destinationUrl);
                        if (isRelativeUrl(destinationUrl)) {
                            // Redirect to the received destination URL
                            console.log("isRelativeUrl");
                            console.log("QrCode navigate to "+`${params.language ? `/${params.language}` : ''}${parsedUrl.pathname}`);
                            navigate(`${params.language ? `/${params.language}` : ''}${parsedUrl.pathname}`, {replace: true});
                        } else {
                            // Handle absolute URL redirection (also to external urls because the QR code is valid
                            console.log("window.open " + destinationUrl);
                            window.open(destinationUrl, '_self');

                        }
                    } catch (e) {
                        console.log(e);
                        console.log("error, redirect to /points");
                        navigate('/points', { replace: true });
                    }

                } else {
                    // If the code is invalid, redirect to /points
                    console.log("the code is invalid, redirect to /points");
                    navigate('/points', { replace: true });
                }

            } catch (error) {
                // Handle errors
                console.log('API request failed')
                console.error(error);
                navigate('/points', { replace: true });
            }
        };

        if (params.qrcode) {
            fetchData(); // Call the asynchronous function immediately
        }


    }, [params, navigate, location]);

    const isRelativeUrl = (url) => {
        try {
            const parsedUrl = new URL(url);
            const hostname = window.location.hostname.replace('dev.tourio.com','tourio.com');
            return parsedUrl.hostname === hostname;
        } catch (error) {
            // Invalid URL, treat it as relative
            return true;
        }
    };

    return (
        <Loading loading={loading} />
        );
}
